import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import RentAdvantagesTemplate from '@components/RentAdvantages/RentAdvantages';
import RentParametersTemplate from '@components/RentParameters/RentParameters';
import RentSupport from '@components/RentSupport/RentSupport';
import useTranslation from '@hooks/useTranslation';
import HeroTemplate from '@ui/Hero/Hero';
import { IS_PROD } from '../constants';

interface IClassroomRent {}

const ClassroomRent: NextPage<IClassroomRent> = () => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo title={t('seo.classroomRent.title')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <HeroTemplate
                titleKey="classroomRent.hero.title"
                imageKey="classroom_rent_hero.png"
                descriptionKey="classroomRent.hero.paragraph"
            />
            <RentAdvantagesTemplate />
            <RentParametersTemplate />
            <RentSupport />
            <FooterTemplate />
        </>
    );
};

export default ClassroomRent;
